<template>
  <div>
    <div class="row text-left" v-if="!loading">
      <div class="col-md-7 p-4">
        <img src="@/assets/img/login.svg" class="img-fluid" />
      </div>
      <div class="col-md-5 align-self-center">
        <h1 class="h4">Login</h1>
        <p class="lead mb-3">Continue to Superchargify Dashboard</p>

        <form action="/shopify/auth" method="get" @submit="submit">
          <div class="form-group">
            <input type="text" class="form-control form-control-lg" placeholder="yourstore.myshopify.com" name="shop" required v-model="shopID" pattern="[A-Za-z0-9\-]+.myshopify.com">
          </div>

          <button type="submit" class="btn btn-primary" :disabled="disableTheButton">Continue</button>
        </form>
      </div>
    </div>
    <Loading v-else />
    <Footer class="mt-5" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Footer from '@/components/Footer'

export default {
  components: {
    Footer
  },
  computed: mapState([ 'loading' ]),
  data: function () {
    return {
      shopID: '',
      disableTheButton: false
    }
  },
  methods: {
    submit: function () {
      if (this.shopID && this.shopID.endsWith('.myshopify.com')) {
        this.disableTheButton = true
      }
    }
  }
}
</script>
